import React, {useState} from "react";
import usePortalService from '../../services/PortalService';
import TextArea from "antd/es/input/TextArea";
import { Radio, Space, Button } from 'antd';
import { useNavigate } from "react-router-dom";

import type { RadioChangeEvent } from 'antd';
import { Vacancy } from "../../types";
import { StyledModal } from "./StyledModal";

type InviteCandidateProps = {
  isOpen: boolean,
  close: () => void,
  profileId: number
};

export const InviteCandidate = ({isOpen, close, profileId} : InviteCandidateProps) => {
  const {listVacancyLightWeightByCompany, reactToProfile, checkExistenceReaction} = usePortalService();
  const navigate = useNavigate();

  const [selectedVacancy, setSelectedVacancy] = useState<Vacancy>()
  const [listVacancies, setListVacancies] = useState<Vacancy[]>([])

  const [message, setMessage] = useState('')

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isApplyOpen, setIsApplyOpen] = useState(false);
  const [isInvitationExistence, setInvitationExistence] = useState(false);
  const [reactionId, setReactionId] = useState<string | null>(null);

  const handleVacancyChange = (e: RadioChangeEvent) => {
    setSelectedVacancy(e.target.value);
  };

  const handleClose = () => {
    setIsApplyOpen(false)
    setInvitationExistence(false);
    close();
  }

  const applyHandler = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!selectedVacancy) return;

    const result = await reactToProfile({
      vacancyId: selectedVacancy.id,
      profileId,
      message
    });

    if (result.success) {
      handleClose();
    }
  }

  const handleContinue = () => {
    if (selectedVacancy) {
      checkExistenceReaction({
        vacancyId: selectedVacancy.id,
        profileId
      }).then(result => {
        if (result.success) {
          if (result.isExistence) {
            setInvitationExistence(true);
            setReactionId(result.reactionId);
          }
          else {
            setIsApplyOpen(true);
          }
        }
      })
    }
  }

  if (isOpen && !isDataLoaded) {
    listVacancyLightWeightByCompany().then(result => {
      if (result.success) {
        setIsDataLoaded(true);
        setListVacancies(result.vacancies);
      }
    })
  }

  if (isInvitationExistence) return (
    <StyledModal 
      title="Вы уже приглашали этого кандидата" 
      open={isInvitationExistence}
      footer={[
        <Button onClick={handleClose} key="back">
          Закрыть
        </Button>,
        <Button type="primary" onClick={() => navigate(`/reaction/${reactionId}`)} key="submit">
          Перейти к приглашению
        </Button>
      ]}
      onCancel={handleClose}
    >
      <p> Вы уже приглашали этого кандидата на данную вакансию или он откликался на неё ранее. </p>
    </StyledModal>
  )

  if (isApplyOpen) return (
    <StyledModal 
      title="Пригласить кандидата" 
      open={isOpen}
      footer={[
        <Button type="text" style={{float: 'left'}}
          onClick={() => setIsApplyOpen(false)} key="back">
          Назад
        </Button>,
        <Button onClick={handleClose} style={{marginRight: '6px'}} key="reject">
          Отмена
        </Button>,
        <Button type="primary" onClick={applyHandler} key="submit">
          Пригласить
        </Button>
      ]}
      onCancel={handleClose}
    >
      <p style={{marginBottom:'12px'}}> Вакансия: {selectedVacancy?.name}</p>
      <p style={{marginBottom:'2px'}}> Текст сообщения </p>
      <TextArea rows={12} value={message} onChange={e => setMessage(e.target.value)}/>
    </StyledModal>
  )

  return(
    <StyledModal 
      title="Пригласить кандидата" 
      open={isOpen}
      footer={[
        <Button onClick={handleClose} style={{marginRight: '6px'}} key="back">
          Отмена
        </Button>,
        <Button type="primary" onClick={handleContinue} key="submit">
          Продолжить
        </Button>
      ]}
      onCancel={handleClose}
    >
      <p style={{marginBottom:'16px'}}> Выберите вакансию: </p>
      <Radio.Group onChange={handleVacancyChange} value={selectedVacancy}>
        <Space direction="vertical">
          {listVacancies.map(item => (
            <Radio value={item} key={item.id}> <p>{item.name}</p> </Radio>
          ))}
        </Space>
      </Radio.Group>
    </StyledModal>
  )
}